module.exports = __webpack_public_path__ + "images/emoji/construction.1d12f3d6e05205aaecfb.png";